import { useApplicationContext } from '../../utils/applicationContext';

export interface IDailyrentBookingsMenuLinks {
  hostLabel: string;
  hostUrl: string;
  guestLabel: string;
  guestUrl: string;
}

export const useDailyrentBookingsMenuLinks = (): IDailyrentBookingsMenuLinks => {
  const { config } = useApplicationContext();

  return {
    hostLabel: config.get<string>('Dailyrent.MyBookingsEntryPoints.HostLabel') || 'Брони и гости',
    hostUrl:
      config.get<string>('Dailyrent.MyBookingsEntryPoints.HostUrl') || 'https://my.cian.ru/dailyrent/hosted-trips',
    guestLabel: config.get<string>('Dailyrent.MyBookingsEntryPoints.GuestLabel') || 'Поездки',
    guestUrl: config.get<string>('Dailyrent.MyBookingsEntryPoints.GuestUrl') || 'https://my.cian.ru/dailyrent/my-trips',
  };
};
